<template>
  <div class="Home">
    <swiper></swiper>
    <!--<infoSwiper></infoSwiper>-->
    <div class="content">
      <div class="product-service">
        <div class="title">产品与服务</div>
        <div class="flex">
          <div
            class="icon-box"
            v-for="(item,index) in iconList"
            :key="index"
            @mouseover="selectStyle (item) "
            :class="{'active':item.txt == selectName}"
            @mouseout="outStyle(item)"
          >
            <img :src="item.simg" v-if="item.txt == selectName">
            <img :src="item.img" v-if="item.txt != selectName">
            <div class="color" :class="{'active-color':item.txt == selectName}">{{ item.txt }}</div>
          </div>
        </div>
      </div>
      <div class="introduce" v-if="selectName=='一站式跨境金融服务'">
        <span>01</span>
        <div class="txt">
          专注为跨境企业和个人客户提供国际收付、货币兑换、供应链融资、汇率风险管理方案等一站式跨境金融服务。
          <router-link class="more" to="/detail">了解更多</router-link>
        </div>
        <i class="end-img"></i>
      </div>
      <div class="introduce" v-if="selectName=='全方位电商解决方案'">
        <span>02</span>
        <div class="txt">
          为您打造专属的互联网商城（独立品牌），同时提供法律、保险、物流、引流等电商增值服务，让您专心做电商业务。
          <router-link class="more" to="/shop">了解更多</router-link>
        </div>
        <i class="end-img2"></i>
      </div>
      <div class="introduce" v-if="selectName=='金融系统开发'">
        <span>03</span>
        <div class="txt">
          一站式解决跨境交易中各类金融系统的开发和技术维护问题，为客户提供从平台前端到后台系统管理、从风控管理到售后技术服务的全方位解决方案。
          <router-link class="more" to="/system">了解更多</router-link>
        </div>
        <i class="end-img3"></i>
      </div>
      <!--<div class="introduce" v-if="selectName=='电商增值服务'">-->
        <!--<span>04</span>-->
        <!--<div class="txt">互联网商城提供个性化增值服务。-->
          <!--<div class="more">了解更多</div>-->
        <!--</div>-->
        <!--<i class="end-img5"></i>-->
      <!--</div>-->

      <div class="news">
        <div class="title">新闻动态</div>
        <div class="content">
          <span class="news-more" @click="more()">更多>></span>
          <div class="news-img">
            <img class="news-img" src="../assets/images/home_news.jpg">
          </div>
          <div class="time-axis">
            <div
              style="display: flex"
              v-for="(item,index) in timeAxisList"
              :key="index"
              @click="selectAxisIndex(index)"
            >
              <div class="time">
                <div>{{item.year}}</div>
                <div>{{item.month}}</div>
                <i class="dot-first" :class="{'select-dot': axisIndex == index}" v-if="index==0"></i>
                <i class="dot" :class="{'select-dot': axisIndex == index}"></i>
                <i class="dot-last" :class="{'select-dot': axisIndex == index}" v-if="index==3"></i>
              </div>
              <div class="txt">
                <div>{{item.title}}</div>
                <div>{{item.val}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="GEP">
        <img class="dev-banner" src="../assets/images/development _history.jpg" alt>
        <div class="GEP-box">
          <div class="name">
            <span>GET</span>
            <span>About US</span>
          </div>
          <div class="gep-content">
            <div class="GEP-img">
              <img class="GEP-img" src="../assets/images/GEP.jpg" alt>
            </div>
            <div class="content">
              <div class="txt">
                GET（全称Global E-tech Holding Limited）为新一代贸易金融科技品牌，独立运营于2018年2月，定位为贸易金融科技公司。我们着眼于供应商及全球贸易市场，专注服务于制造业出口及跨境电商、跨境贸易等金融需求。通过国际领先的贸易大数据应用技术和量化风控模型，建立起国际风控体系、国际支付体系、信用体系、实时汇率体系等一整套贸易与金融底层基础设施，与国际电商平台、物流企业、海外仓企业、ERP企业深度合作，释放跨境支付领域的优势，为国际贸易链提供高效、可靠和低成本的综合金融科技解决方案，打造更为开放、更可连接、更加互信的国际贸易商业文明。<br/><br/>2018年至今，GET陆续在美国、香港、日本、新加坡、中国等地设立子公司，分别为GEP美国、GEP香港、GEP日本、GEP新加坡、GEP中国，并预计未来业务将拓展至新加坡、欧盟等地。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cooperative-client">
        <!--<div class="title">合作客户</div>-->
        <!--<div class="content">-->
          <!--<img src="../assets/images/bitmap.png">-->
        <!--</div>-->
      </div>
    </div>
    <!--<div class="sidebar">-->
      <!--<div class="sidebar-icon-box" v-for="(item,index) in sidebarList" :key="index">-->
        <!--<img :src="item.img" alt>-->
      <!--</div>-->
    <!--</div>-->
    <!--<sidebar></sidebar>-->
    <footer>
      <footContent></footContent>
    </footer>
  </div>
</template>
<script>
import FootContent from "../components/FootContent.vue";
import Swiper from "../components/Swiper.vue";

export default {
  components: {
    footContent: FootContent,
    swiper: Swiper,
  },
  data() {
    return {
      active: false,
      selectName: "一站式跨境金融服务",
      axisIndex: 0,

      iconList: [
        {
          img: require("../assets/images/payment.png"),
          simg: require("../assets/images/payment_s.png"),
          txt: "一站式跨境金融服务"
        },
        {
          img: require("../assets/images/finance.png"),
          simg: require("../assets/images/finance_s.png"),
          txt: "全方位电商解决方案"
        },
        {
          img: require("../assets/images/electronic-business-plan.png"),
          simg: require("../assets/images/electronic-business-plan_s.png"),
          txt: "金融系统开发"
        },
        // {
        //   img: require("../assets/images/electricity-supplier-service.png"),
        //   simg: require("../assets/images/electricity-supplier-service_s.png"),
        //   txt: "电商增值服务"
        // }
      ],
      timeAxisList: [
          {
              year: "2019",
              month: "07-26",
              title: "上半年跨境电商进口货值；无锡跨境电商综…",
              val: "据海关总署税收征管局（上海）统计，今年…"
          },
          {
              year: "2019",
              month: "07-12",
              title: "葡萄酒跨境电商交易；关税豁免；深圳鼎付暂停收款…",
              val: "湖北首家依托一带一路、中欧班列打造的葡萄酒保税仓…"
          },
          {
              year: "2019",
              month: "07-05",
              title: "跨境电商零售；Lazada年中大促…",
              val: "海关下半年重点打击侵权产…"
          },
      ]
    };
  },
  computed: {},
  mounted() {},
  methods: {
    // 鼠标进入焦点时
    selectStyle(item) {
      var _this = this;
      this.$nextTick(function() {
        this.iconList.forEach(function(item) {
          _this.$set(item, "active", false);
        });
        this.$set(item, "active", true);
        this.selectName = item.txt;
      });
    },
    // 鼠标离开焦点时
    outStyle(item) {
      this.$set(item, "active", false);
    },
    selectAxisIndex(index) {
      switch(index) {
          case 0:
              this.$router.push('/news/news-detail-3');
              break;
          case 1:
              this.$router.push('/news/news-detail-2');
              break;
          case 2:
              this.$router.push('/news/news-detail-1');
              break;
          default:
      }
      this.axisIndex = index;
    },
    more() {
      this.$router.push("/news");
    }
  }
};
</script>

<style lang="scss">
.Home {

  .info-swiper-components {
    margin-top: -44px;
  }
  .content {
    width: 100%;
    text-align: center;
    .title {
      width: 158px;
      height: 45px;
      font-size: 30px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #323232;
      line-height: 21px;
      letter-spacing: 1px;
      position: relative;
      margin: auto;
    }
    .title::after {
      content: "";
      width: 80px;
      height: 3px;
      position: absolute;
      top: 41px;
      left: 38px;
      background: linear-gradient(270deg, #988ef5 0%, #4f3df5 100%);
    }
    .flex {
      display: flex;
    }
    .product-service {
      margin: 60px auto 0 auto;
      width: 1200px;
      .active {
        color: rgba(255, 255, 255, 1);
        background: linear-gradient(
          180deg,
          rgba(82, 63, 198, 1) 0%,
          rgba(47, 35, 162, 1) 100%
        );
        opacity: 0.7006999999999999;
      }

      .icon-box {
        flex: 1;
        width: 240px;
        height: 240px;
        margin-top: 60px;
        margin-bottom: 23px;
        img {
          width: 82px;
          height: 82px;
          margin-top: 50px;
          z-index: 1000;
        }
        .color {
          height: 25px;
          font-size: 18px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(50, 50, 50, 1);
          line-height: 25px;
          margin-top: 31px;
        }
        .active-color {
          color: rgba(255, 255, 255, 1) !important;
        }
      }
    }
    .introduce {
      width: 1199px;
      height: 144px;
      background: rgba(251, 252, 252, 1);
      border-radius: 1px;
      margin: auto;
      position: relative;
      span {
        text-indent: 0;
        font-size: 100px;
        color: rgba(0, 0, 0, 0.06);
        font-weight: 700;
        position: absolute;
        left: 13px;
        top: 4px;
      }
      .txt {
        width: 900px;
        height: 87px;
        font-size: 16px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(50, 50, 50, 0.79);
        line-height: 29px;
        text-align: left;
        padding: 40px 0 0 20px;
        .more {
          display: inline-block;
          width: 82px;
          height: 24px;
          opacity: 0.7983;
          border: 1px solid rgba(100, 85, 218, 1);
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(83, 67, 204, 1);
          line-height: 24px;
          text-align: center;
          float: right;
          margin: 21px 13px 0 0;
        }
      }
      .end-img {
        position: relative;
      }
      .end-img::before {
        content: "";
        background: url(../assets/images/introduce_1.png) no-repeat top
          left/160px 122px;
        position: absolute;
        top: -106px;
        z-index: 2;
        right: -600px;
        width: 160px;
        height: 122px;
      }
      .end-img2 {
        position: relative;
      }
      .end-img2::before {
        content: "";
        background: url(../assets/images/introduce_2.png) no-repeat top
          left/160px 122px;
        position: absolute;
        top: -106px;
        z-index: 2;
        right: -600px;
        width: 160px;
        height: 122px;
      }
      .end-img3 {
        position: relative;
      }
      .end-img3::before {
        content: "";
        background: url(../assets/images/introduce_3.png) no-repeat top
          left/160px 122px;
        position: absolute;
        top: -106px;
        z-index: 2;
        right: -600px;
        width: 160px;
        height: 122px;
      }
      .end-img4 {
        position: relative;
      }
      .end-img4::before {
        content: "";
        background: url(../assets/images/introduce_4.png) no-repeat top
          left/160px 122px;
        position: absolute;
        top: -106px;
        z-index: 2;
        right: -600px;
        width: 160px;
        height: 122px;
      }
      .end-img5 {
        position: relative;
      }
      .end-img5::before {
        content: "";
        background: url(../assets/images/introduce_5.png) no-repeat top
          left/160px 122px;
        position: absolute;
        top: -106px;
        z-index: 2;
        right: -600px;
        width: 160px;
        height: 122px;
      }
    }
    .news {
      margin-top: 120px;

      .content {
        width: 1200px;
        height: 450px;
        background: rgba(250, 250, 250, 1);
        border-radius: 1px;
        margin: 60px auto 0 auto;
        display: flex;
        position: relative;
        .news-more {
          cursor: pointer;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: #323232;
          line-height: 20px;
          position: absolute;
          right: 1px;
          top: -26px;
        }
        .news-img {
          width: 684px;
          height: 450px;
        }
        .time-axis {
          display: flex;
          margin: 43px 35px 25px 35px;
          flex-wrap: wrap;
          cursor: pointer;
          & > div:hover > .time i {
            width: 13px;
            height: 13px;
            background: white;
            border: 3px solid #5f51d7 !important;
            position: absolute;
            right: -11px;
            top: 15px;
            border-radius: 100%;
          }
          .time {
            text-align: center;
            margin-right: 29px;
            border-right: 2px solid #e6e6e6;
            padding-right: 21px;
            position: relative;
          }
          .time div:first-child {
            width: 47px;
            height: 22px;
            font-size: 16px;
            font-family: NewPingfang;
            font-weight: 800;
            color: rgba(50, 50, 50, 1);
            line-height: 22px;
            margin-bottom: 10px;
          }
          .time div:nth-child(2){
            width: 52px;
            height: 22px;
            font-size: 16px;
            font-family: NewPingfang;
            font-weight: 800;
            color: rgba(0, 0, 0, 0.25);
          }
          .dot {
            width: 13px;
            height: 13px;
            background: white;
            border: 3px solid rgba(221, 221, 221, 1);
            position: absolute;
            right: -11px;
            top: 15px;
            border-radius: 100%;
          }
          .select-dot {
            width: 13px;
            height: 13px;
            background: white;
            border: 3px solid #5f51d7 !important;
            position: absolute;
            right: -11px;
            top: 15px;
            border-radius: 100%;
          }

          .dot-first {
            width: 13px;
            height: 13px;
            background: white;
            border: 3px solid rgba(221, 221, 221, 1);
            position: absolute;
            right: -11px;
            top: 15px;
            border-radius: 100%;
          }
          .dot-first::after {
            content: "";
            width: 13px;
            height: 22px;
            position: absolute;
            top: -26px;
            left: 1px;
            background: #fafafa;
          }
          .dot-last {
            width: 13px;
            height: 13px;
            background: white;
            border: 3px solid rgba(221, 221, 221, 1);
            position: absolute;
            right: -11px;
            top: 15px;
            border-radius: 100%;
          }
          .dot-last::after {
            content: "";
            width: 13px;
            height: 60px;
            position: absolute;
            top: 20px;
            left: 1px;
            background: #fafafa;
          }
          .txt {
            text-align: left;
          }
          .txt div:first-child {
            width: 336px;
            font-size: 16px;
            font-family: NewPingfang Medium;
            font-weight: 800;
            color: rgba(50, 50, 50, 1);
            line-height: 22px;
            margin-bottom: 10px;
          }
          .txt div:last-child {
            width: 220px;
            font-size: 16px;
            font-family: NewPingfang;
            font-weight: 800;
            color: rgba(0, 0, 0, 0.25);
            line-height: 22px;
          }
        }
      }
    }
    .GEP {
      margin: 153px 0 0 0;
      width: 100%;
      height: 687px;
      .dev-banner {
        width: 100%;
        height: 406px;
      }
      .GEP-box {
        width: 1041px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 2px 24px 0 rgba(6, 2, 44, 0.14);
        border-radius: 49px 0 49px 0;
        top: -309px;
        margin: auto;
        position: relative;
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 40px 40px 65px 40px;
        .name {
          font-size: 18px;
          font-family: PingFang-SC-Bold;
          font-weight: bold;
          color: rgba(50, 50, 50, 1);
          line-height: 32px;
          text-align: left;
          margin-bottom: 10px;
          span:last-child {
            width: 77px;
            height: 30px;
            font-size: 16px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(50, 50, 50, 1);
            line-height: 30px;
            margin-left: 20px;
          }
        }
        .gep-content {
          display: flex;
          flex-flow:row nowrap;
          justify-content: space-between;
          align-items: flex-start;

          .GEP-img {
            width: 360px;
            height: 360px;
          }

          .content {
            padding: 0 0 0 25px;
            .txt {
              font-size: 16px;
              font-family: NewPingfang, sans-serif !important;
              text-align: justify;
              justify-content: space-between;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.5);
              line-height: 32px;
            }
          }
        }
      }
    }
    .cooperative-client {
      margin: 120px 0;
      .content {
        background: rgba(250, 250, 250, 1);
        margin-top: 60px;
        img {
          width: 1204px;
          height: auto;
        }
      }
    }
  }
}
</style>
